// removed by extract-text-webpack-plugin
module.exports = {"container":"_1m39X","titleContainer":"_1xmlg","title":"Uy52Y","message":"_1jmvq","reason":"_1f4t4","separator":"M0iBI","radioInput":"_2slWS","form":"IjTLo","reasons":"_2HWxP"};


//////////////////
// WEBPACK FOOTER
// ./app/components/report-abuse-form/report-abuse-form.scss
// module id = 869
// module chunks = 3 4 5 6 7